import { FormattedNumber } from 'react-intl'

const Price = ({ value, currency, style, className = '' }) =>
    value != null && (
        <span className={className}>
            <FormattedNumber value={value} currency={currency} style={style} />
        </span>
    )

export default Price
